import type { PointLink } from './point.types';

export class PointService {
    private static readonly ExternalPrefix = 'https://';
    private static readonly ExternalTarget = '_blank';
    private static readonly ExternalRel = 'noopener noreferrer';

    /**
     * Einheitliche Link-Ableitung für NavPoint und DropdownPoint.
     * Ein leerer oder fehlender href bedeutet "kein Link".
     */
    public buildLink(href: string | undefined): PointLink {
        const Url = (href ?? '').trim();
        const HasLink = Url !== '';
        const Target = HasLink && Url.startsWith(PointService.ExternalPrefix) ? PointService.ExternalTarget : undefined;

        return {
            url: Url,
            hasLink: HasLink,
            target: Target,
            rel: Target === undefined ? undefined : PointService.ExternalRel,
        };
    }
}
